module.exports = __webpack_public_path__ + "static/media/watermark3.47a5253a.png";